var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9084 4.98239V5.50278V6.02321V11.6259H15.959H16.4794H16.9998V4.98239H11.9084Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.98239V11.6259H0.520393H1.04082H5.26203V6.02321V5.50278V4.98239H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.7657V12.6668H16.4796H15.9592H1.04082H0.520393H0V14.7657H7.36379V15.9419H5.27349V16.9827H11.7265V15.9419H9.63621V14.7657H17ZM8.857 13.7249V14.0424H8.13709V13.7249V13.3225H8.857V13.7249Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4267 4.98239H9.90628H7.26155H6.74116H6.30298V5.00284V6.02321V11.6259H6.74116H7.26155H9.90628H10.4267H10.868V6.02321V5.50278V5.00284V4.98239H10.4267Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58392 0.0173264L6.36279 3.96202H6.96022H7.55731H9.61016H10.2072H10.8047L8.58392 0.0173264Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.5bdf3a4b.svg";
export { ForwardRef as ReactComponent };